import { syncObjectProperties } from '@shared-helpers/array-object-helpers';
import {
  ICondToDefault,
  ICondToMat,
  ICondToSkf,
  ICondToTimesheetHdr,
  ISapResponseContractCondition,
} from '@shared-interfaces/api';

import { ITableConfigEntity } from '../interfaces/internal-interfaces';
import { ExtDocument } from './extDocument';

export class ConditionHandler {
  CustGroup: string;
  CondGroup: string;
  ContractId: string;
  CustGroupDescription: string;
  CondGroupDescription: string;
  ServiceOrder: string;
  SalesOrg: string;
  DistrChannel: string;
  Division: string;
  COArea: string;
  CondToSkf: ICondToSkf;
  CondToMat: ICondToMat;
  CondToDefault: ICondToDefault;
  CondToTimesheetHdr: ICondToTimesheetHdr;
  shouldHideCloseButton?: boolean;
  CostCenter?: string;

  config: ITableConfigEntity<keyof ExtDocument>[] = [];

  constructor(conditionEntity: ISapResponseContractCondition) {
    syncObjectProperties(conditionEntity, this, false);
  }
}
